// extracted by mini-css-extract-plugin
export var modal = "_ug-0";
export var table = "_ug-1";